import axios from 'axios';

type ErrorMap = Record<string, string>;

const ERROR_CODES: ErrorMap = {
    '400': 'Запрос содержит некорректные данные. Проверьте введённую информацию и попробуйте снова.',
    '401': 'Не удалось авторизоваться. Пожалуйста, убедитесь, что правильно ввели логин и пароль.',
    '403': 'Извините, но у вас нет разрешения на доступ к этому ресурсу. Пожалуйста, обратитесь к администратору системы.',
    '404': 'Запрашиваемый ресурс не найден. Пожалуйста, проверьте корректность ссылки или попробуйте выполнить действие ещё раз.',
    '500': 'К сожалению, произошла внутренняя ошибка сервера при попытке авторизации. Пожалуйста, попробуйте позже.',
};

const ERROR_RESPONSE_CODES: ErrorMap = {
    RESET_TOKEN_EXPIRED:
        'Ссылка для сброса пароля недействительна. Пожалуйста, запросите восстановление пароля ещё раз.',
    LATIN_DIGITS_WITH_CASE:
        'Пароль должен содержать хотя бы одну строчную и одну заглавную латинскую букву.',
    ONLY_ALLOWED_CHARS: 
        'Пароль может содержать только латинские буквы, цифры и символы: @.,+-_!?#$%^&*',
    PASSWORD_SAME_AS_CURRENT:
        'Новый пароль не должен совпадать с текущим. Пожалуйста, придумайте другой пароль.',
    INVALID_CREDENTIALS:
        'Неверный логин или пароль. Проверьте введённые данные и попробуйте снова.',
    INVALID_EMAIL:
        'Указан некорректный адрес электронной почты. Проверьте формат и попробуйте снова.',
};

function getResponseCode(data: unknown): string | undefined {
    if (typeof data === 'object' && data !== null && 'code' in data) {
        const code = (data as { code?: unknown }).code;
        return code == null ? undefined : String(code);
    }
    return undefined;
}

export function handleAxiosError(error: unknown): never {
    // 1) не axios-ошибка
    if (!axios.isAxiosError(error)) {
        throw new Error('Неизвестная ошибка при загрузке данных.');
    }

    // 2) отмена запроса
    if (error.code === 'ERR_CANCELED') {
        throw new Error('canceled');
    }

    // 3) нет ответа от сервера (сеть/CORS/DNS/таймауты без response)
    if (!error.response) {
        throw new Error('Не удалось загрузить данные. Сервер не ответил или произошла ошибка сети.');
    }

    // 4) есть ответ: собираем сообщение
    const { status, data } = error.response;

    const responseCode = getResponseCode(data);

    const message =
        (responseCode ? ERROR_RESPONSE_CODES[responseCode] : undefined) ??
        ERROR_CODES[String(status)] ??
        'Неизвестная ошибка при загрузке данных.';

    throw new Error(message);
}
